<ng-container>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="filters-area" style="display: flex; justify-content: space-between;">
    <div class="filter">
      <div class="search-container" (click)="setSearchFocus()" [class.search-focus]="isFocusSearch" [class.disabled]="isLoading" style="height: 30px"><i class="material-icons" style="padding:6px 10px;">search</i>
        <input autocomplete="off" type="text" placeholder="Search..." [(ngModel)]="searchText" (input)="search()"/>
      </div>
      <div class="relative" #statusFilterbox>
        <div class="btn-area ml-10">
          <div class="button button-white dense-icon-btn" [class.disabled]="isLoading" (click)="toggleStatusFilter()">
            <div class="btn-inner dense-icon-btn filter-btn" style="margin: 4px 10px; gap: 4px;"><span [ngClass]="selectedStatus === 'All' ? 'all' : selectedStatus === 'Online' ? 'online' : 'offline'">{{ selectedStatus }}</span>
              <comp-icon class="filter-icon" [icon]="'expend_more'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon>
            </div>
          </div>
        </div>
        <div class="filter-box" *ngIf="showStatusFilterbox" style="width: 180px; position: absolute; top: 30px; left: 10px;">
          <div class="select-list" style="width: max-content">
            <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
              <div class="select-result has-child selectitem" *ngFor="let item of statusFilterItems" (click)="selectStatusFilter(item)">
                <div><span [ngClass]="item === 'All' ? 'all' : item === 'Online' ? 'online' : 'offline'">{{ item }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative" #typeFilterbox>
        <div class="btn-area ml-10">
          <div class="button button-white dense-icon-btn" [class.disabled]="isLoading" (click)="toggleTypeFilter()">
            <div class="btn-inner dense-icon-btn filter-btn" style="gap: 4px;">
              <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Type</span><span class="exist-filter" *ngIf="selectedType?.length">{{ selectedType?.length }}</span>
            </div>
          </div>
        </div>
        <div class="filter-box" *ngIf="showTypeFilterbox" style="width: 180px; position: absolute; top: 30px; left: 10px;">
          <div class="select-list" style="width: max-content">
            <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
              <div class="select-result has-child selectitem" *ngFor="let item of typeFilterItems" (click)="selectTypeItem(item)">
                <div class="check-area"><i class="material-icons check-icon" *ngIf="!hasTypeFilter(item)">check_box_outline_blank</i><i class="material-icons check-icon checked" *ngIf="hasTypeFilter(item)">check_box</i></div>
                <div>{{ item }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative" #siteFilterbox>
        <div class="btn-area ml-10">
          <div class="button button-white dense-icon-btn" [class.disabled]="isLoading" (click)="toggleSiteFilter()">
            <div class="btn-inner dense-icon-btn filter-btn" style="gap: 4px;">
              <div *ngIf="!selectedSite">
                <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Site Filter</span>
              </div>
              <ng-container *ngIf="selectedSite" (click)="showSiteFilterbox = true"><i class="material-icons filter-icon">person</i><span class="exist-filter ellipsis" *ngIf="selectedSite" style="max-width: 200px;">{{ selectedSite.site_name }}</span><i class="material-icons filter-icon" style="margin-left: 8px;" (click)="$event.stopPropagation();clearSiteFilter()">cancel</i></ng-container>
            </div>
          </div>
          <div class="filter-box" *ngIf="showSiteFilterbox">
            <div class="select-list" #siteSelect>
              <div class="search-result-input">
                <input class="list-search-input" autocomplete="off" type="text" #selectSearchInput placeholder="Search Site" [(ngModel)]="searchSiteText" (input)="searchSite(searchSiteText)"/>
              </div>
              <div style="max-height: 200px;overflow-y: auto; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="select-result has-child selectitem" *ngFor="let site of filteredSiteList" (click)="$event.stopPropagation();selectSite(site)">
                  <div class="ellipsis" [class.selected]="site?.site_id === selectedSite?.site_id">{{ site.site_name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-area" style="margin-left: 16px">
      <div class="button button-white dense-icon-btn" (click)="createCSV()" [class.disabled]="isLoadingForCSV || isLoading">
        <div class="btn-inner dense-icon-btn">Create CSV</div>
      </div>
    </div>
  </div>
  <div class="table-area" *ngIf="!isLoading">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumn($event)">
        <colgroup>
          <col *ngFor="let col of tableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of tableHeader" [sortable-column]="header.value">{{header.name}}</th>
          </tr>
        </thead>
      </table>
      <div class="alternative-contents" *ngIf="!isLoading && filteredDeviceList.length === 0"><i class="material-icons">inventory_2</i>
        <div>No Device List</div>
      </div>
      <div class="table-body">
        <table>
          <colgroup>
            <col *ngFor="let col of tableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <ng-container *ngIf="!isLoading">
              <tr *ngFor="let device of pagedItems; let i = index; trackBy: trackByDevice">
                <td>{{ device.site_id }}</td>
                <td [class.no-contents]="device.site_name === 'No Site Name'">{{ device.site_name }}</td>
                <td>{{ device.type }}</td>
                <td [class.no-contents]="device.zone_number === 'No Zone Number'">{{ device.zone_number }}</td>
                <td [class.no-contents]="device.device_name === 'No Device Name'">{{ device.device_name }}</td>
                <td [class.no-contents]="device.brand === 'No Data'">{{ device.brand }}</td>
                <td [class.no-contents]="device.model === 'No Data'">{{ device.model }}</td>
                <td [class.no-contents]="device.firmware === 'No Data'">{{ device.firmware }}</td>
                <td><span [ngClass]="device.status === 'Online' ? 'online' : 'offline'">{{ device.status }}</span></td>
                <td> 
                  <div [class.no-contents]="device.status_date === 'No Data'">{{ device.status_date }}</div>
                </td>
                <td>
                  <div class="more-content v-center" #deviceActionMenus [id]="'device-' + i + device.device_name" (mouseover)="setMorePosition($event,device,i)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(device)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [class.show]="device.isShowMenu" [id]="'more-device-' + i + device.device_name">
                      <div class="more-item row" (click)="goToSiteDevices(device.site_id)">
                        <div>Go to Site</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- pagination-->
      <div class="pagination-area">
        <div style="font-size:12px;padding-right: 7px;"></div>
        <div class="space"></div>
        <div class="flex" style="font-size:12px;padding-right: 7px; gap: 2px">
          <div>{{pageOffsetStart}} - {{pageOffsetEnd}}</div>
          <div>of</div>
          <div>{{totalItem}}</div>
        </div>
        <div class="pagination">
          <div class="page-mover">
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0" (click)="setPage(pager.currentPage - 1)">
                <div class="btn-inner"><i class="material-icons" style="font-size: 16px" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0">arrow_back</i><span>Prev</span></div>
              </div>
            </div>
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === pager.totalPages" (click)="setPage(pager.currentPage + 1)">
                <div class="btn-inner"><span>Next</span>
                  <comp-icon [icon]="'arrow_forward_n'" [color]="'#000'" [size]="16" [class.disabled]="pager.currentPage === pager.totalPages"></comp-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>